import React from 'react';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';

const Tools = ({ items }) => (
  <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
    {items.map((item, index) => (
      <li key={index} className="flex items-center">
        <WrenchScrewdriverIcon className="h-5 w-5 text-gray-400" />
        <span className="ml-3 text-gray-600">{item}</span>
      </li>
    ))}
  </ul>
);

export default Tools;
